import { IngredientGroup } from "../recipes/IngredientGroup";
import { Ingredient, SpecificIngredient } from "./Ingredient";

export const AddIngredientFormTemplate = (ingredientType) => {
  Ingredient.min_amount.readOnly =
    ingredientType === "VEGE" || ingredientType === "SEAS";
  Ingredient.max_amount.readOnly = ingredientType === "SEAS";

  return {
    sections: [
      {
        size: 1 / 3,
        compact: true,
        inputs: [
          /*           ingredientType === "SEAS" || ingredientType === "VEGE"
            ? Ingredient.min_amount_disabled
            : Ingredient.min_amount,
          ingredientType === "SEAS"
            ? Ingredient.max_amount_disabled
            : Ingredient.max_amount, */

          Ingredient.min_amount,
          Ingredient.max_amount,

          /*           Ingredient.units,
           */
          /*           Ingredient.home_measure,
           */
        ],
      },
      {
        size: 1 / 3,
        compact: true,
        inputs: [
          Ingredient.priority_weight,
          Ingredient.is_variable,
          Ingredient.is_visible,
        ],
      },
      {
        size: 1,
        compact: true,
        inputs: [
          /*Recipe.veg_ingredients.composedElements.base_preparation,
                    Recipe.veg_ingredients.composedElements.max_elegible_ingredients,
                    Recipe.veg_ingredients.composedElements.ingredient_list,*/
          Ingredient.ingredient_preparation,
        ],
      },
    ],
  };
};

export const AddIngredientGroupFormTemplate = (
  group,
  handleBlurInAVisibleName,
  handleBlurInAGroupPreparation
) => {
  IngredientGroup.min_amount.readOnly = group === "VEGE" || group === "SEAS";
  IngredientGroup.max_amount.readOnly = group === "SEAS";

  //function on blur for visible_name, as we need to check if changes for the D&D
  IngredientGroup.visible_name.onBlur = handleBlurInAVisibleName;

  //function on blur for group_preparation, as we need to check if changes for the preparation buttons
  IngredientGroup.group_preparation.onBlur = handleBlurInAGroupPreparation;

  return {
    sections: [
      {
        title: "Detalles del grupo de ingredientes",
        size: 1 / 2,
        compact: true,
        inputs: [IngredientGroup.visible_name, IngredientGroup.max_weight],
      },
      {
        size: 1 / 2,
        compact: true,
        /*         inputs: [
          group === "SEAS" || group === "VEGE"
            ? IngredientGroup.min_amount_disabled
            : IngredientGroup.min_amount,
          group === "SEAS"
            ? IngredientGroup.max_amount_disabled
            : IngredientGroup.max_amount,

          IngredientGroup.units,
        ], */

        inputs: [
          IngredientGroup.min_amount,
          IngredientGroup.max_amount,
          /*           IngredientGroup.units,
           */
        ],
      },
      {
        size: 1,
        compact: true,
        inputs: [IngredientGroup.group_preparation],
      },
      { title: "Listado de ingredientes" },
    ],
  };
};
